import createLucideIcon from '../createLucideIcon';

const ChevronLeft = createLucideIcon('ChevronLeftIcon', [
  ['polyline', { points: '15 18 9 12 15 6', key: 'kvxz59' }],
]);

export default ChevronLeft;
